import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';

import { KeyboardFacade } from './keyboard.facade';

@Injectable()
export class KeyboardEffects {
  constructor(
    private actions$: Actions,
    private facade: KeyboardFacade,
    private store: Store
  ) {}
}
